import React, { useState } from "react";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { FiltroDeputato, FiltroMembroGoverno, FiltroData } from "../filters";
import { ATTIVITA_OPTIONS } from "../../data/attivita_non_legislativa";
import { REACT_APP_SEARCH } from '../../config';
import axios from 'axios';

const INITIAL_STATE = {
    attivita: null,
    deputato: [],
    governo: { governo: null, membro: [] },
    data: { start: null, end: null },
    ricerca: "NL"
};

export default function FiltroAttivitaNonLegislativa({ onResults, setLoading, setError, searched, onNuovaRicerca }) {
    const [filtri, setFiltri] = useState(INITIAL_STATE);

    const update = (campo) => (valore) =>
        setFiltri((prev) => ({ ...prev, [campo]: valore }));

    const handleSubmit = async () => {
        setLoading?.(true);
        setError?.('');

        try {
            const { data: risultati } = await axios.post(REACT_APP_SEARCH, filtri);
            onResults?.({ risultati, label: 'Leggi' });
        } catch (err) {
            console.error('Errore caricamento risultati Leggi', err);
            onResults?.({ risultati: [], label: 'Leggi' });
            setError?.(err.response?.data?.message || err.message || 'Errore nel caricamento dei risultati.');
        } finally {
            setLoading?.(false);
        }
    };

    return (
        <div>
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="Attività">
                    <div>
                        <Dropdown
                            value={filtri.attivita} onChange={(e) => update('attivita')(e.value ?? null)} filter
                            showClear options={ATTIVITA_OPTIONS} placeholder="Seleziona attività" className="w-full" />
                    </div>
                </AccordionTab>
                <AccordionTab header="Deputato">
                    <FiltroDeputato value={filtri.deputato} onChange={update('deputato')} />
                </AccordionTab>
                <AccordionTab header="Membro di Governo">
                    <FiltroMembroGoverno value={filtri.governo} onChange={update('governo')} />
                </AccordionTab>
                <AccordionTab header="Data">
                    <FiltroData value={filtri.data} onChange={update('data')} />
                </AccordionTab>
            </Accordion>

            <div className="mt-4 flex justify-content-center gap-2">
                <Button label="Avvia la ricerca" size="small" severity="success" onClick={handleSubmit} />
                {searched && (
                    <Button
                        label="Nuova ricerca"
                        severity="secondary"
                        size="small"
                        outlined
                        onClick={onNuovaRicerca}
                    />
                )}
            </div>
        </div>
    )
}
